export default {
    props: {
      now: {
        type: Number,
        require: true
      },
      label: {
        type: Boolean,
        default: false
      },
      type: {
        type: String
      },
      striped: {
        type: Boolean,
        default: false
      },
      animated: {
        type: Boolean,
        default: false
      }
    }
  }


/** WEBPACK FOOTER **
 ** ./src/Progressbar.vue
 **/